<template>
  <div
    class="question-container"
    :style="{
      border:
        dataObj.status === 1
          ? '1px dashed rgba(58,96,255,1)'
          : '1px solid #EDEFF2',
    }"
  >
    <div class="question-type">图片上传</div>
    <div class="title-view">
      <!-- <span style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span
        >{{ `${index + 1}、` }}
        <span style="color: #4c4a56">
          {{ `${dataObj.caseProblem}` }}
          <span class="limitation">(最多上传{{ pictureNum }}张)</span>
        </span>
      </span> -->

      <p class="question-row">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        <span class="index">{{
          `${dataObj.questionIndex || index + 1}、`
        }}</span>

        <!-- 富文本 + 后缀文字 放在同一个容器里 -->
        <span class="rich-text-wrapper">
          <span class="rich-text-content" v-html="dataObj.caseProblem"></span>
          <span
            style="
              position: relative;
              padding: 0 8px;
              line-height: 20px;
              background: rgba(58, 96, 255, 0.09);
              border: 1px solid rgba(58, 96, 255, 0.4);
              border-radius: 4px;
              font-size: 13px;
              font-weight: 500;
              text-align: center;
              color: #3a60ff;
              display: inline-block;
              margin-left: 10px;
            "
          >
            {{ dataObj.questionScore ? dataObj.questionScore : "0" }}分
          </span>
        </span>
      </p>
    </div>
    <div class="question-images">
      <div
        v-for="(item, idx) in images"
        :key="idx"
        style="margin-top: 20px; position: relative"
      >
        <img :src="item" style="width: 100%" />
      </div>
    </div>
    <div
      style="
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        gap: calc((100% - 616px) / 3);
      "
    >
      <div
        class="image-view"
        v-for="(item, idx) in imageList"
        :key="idx"
        @click.stop="showBigImage(item.context)"
      >
        <img
          :src="item.context"
          style="width: 100%; height: 100%; border-radius: 6px"
        />
        <img
          src="@/assets/images/guanbi.png"
          class="delete"
          v-if="!showMask"
          @click.stop="handleDelete(idx)"
        />
        <div class="fangda-box">查看图片</div>
      </div>
      <div
        v-if="imageList.length < pictureNum && !showMask"
        class="image-view"
        @click="handleUpload"
      >
        <div class="plus-icon"></div>
        <span>上传图片</span>
        <span>最大10M</span>
      </div>
    </div>
    <!-- <uploadImage
      :show="showUpload"
      :maxCount="pictureNum"
      :images="imageList.length"
      :limitSize="10"
      @upload-close="showUpload = false"
      @upload-success="handleUploadComplete"
      :onImageSelectStart="handleImageSelectStart"
      :onImageSelectEnd="handleImageSelectEnd"
    ></uploadImage> -->

    <div class="fangda-popup" v-if="fangdaShow" @click="fangdaClose">
      <div class="popup-content" @click.stop>
        <img
          src="@/assets/images/guanbi.png"
          class="popup-guanbi"
          @click="fangdaClose"
        />
        <div class="popup-scroll">
          <div>{{ fangdaTitle }}</div>
          <img :src="fangdaImgUrl" style="width: 100%" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExamPreviewIMAGE",
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    showMask: Boolean,
  },
  data() {
    return {
      index: 0,
      disabled: false,
      showUpload: false,
      pictureNum: 1,
      imageList: [],
      images: [],
      fangdaShow: false,
      fangdaImgUrl: "",
      fangdaTitle: "",
    };
  },
  watch: {
    params: {
      handler(newValue) {
        if (newValue && newValue.data) {
          this.dataObj = newValue.data;
          this.index = newValue.index;
          this.disabled = newValue.data.status !== 4;
          this.pictureNum = newValue.data.pictureNum;
          this.images = JSON.parse(newValue.data.caseProblemImg || "[]");
          const chooseList = JSON.parse(
            newValue.data.chooseList || '{"list":null}',
          );
          this.imageList = chooseList.list === null ? [] : chooseList.list;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleUpload() {
      if (this.dataObj.data.status === 4) {
        this.showUpload = true;
      }
    },
    handleUploadComplete(res) {
      this.imageList = [
        ...this.imageList,
        ...res.map((item) => ({
          id: "",
          context: item,
        })),
      ];

      const updatedData = {
        ...this.dataObj.data,
        chooseList: JSON.stringify({ list: this.imageList }),
      };

      this.$emit(
        "update",
        JSON.stringify({
          data: updatedData,
          index: this.index,
          answer: {
            question_id: this.dataObj.data.id,
            type: this.dataObj.data.type,
            if_hide: this.dataObj.data.if_hide,
            answer: this.imageList,
          },
        }),
      );
      this.showUpload = false;
    },
    handleDelete(index) {
      this.imageList.splice(index, 1);

      const updatedData = {
        ...this.dataObj.data,
        chooseList: JSON.stringify({ list: this.imageList }),
      };

      this.$emit(
        "update",
        JSON.stringify({
          data: updatedData,
          index: this.index,
          answer: {
            question_id: this.dataObj.data.id,
            type: this.dataObj.data.type,
            if_hide: this.dataObj.data.if_hide,
            answer: this.imageList,
          },
        }),
      );
    },
    showBigImage(img) {
      this.fangdaShow = true;
      this.fangdaImgUrl = img;
    },
    fangdaClose() {
      this.fangdaShow = false;
      this.fangdaImgUrl = "";
    },
    handleImageSelectStart() {
      this.$emit("upload");
    },
    handleImageSelectEnd() {
      // Handle image select end
    },
  },
};
</script>

<style lang="scss" scoped>
.image-view {
  width: 154px;
  height: 154px;
  background: #f4f4f4;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
  cursor: pointer;

  .plus-icon {
    position: relative;
    width: 34px;
    height: 34px;
    margin-top: 30px;
    margin-bottom: 16px;

    &::before,
    &::after {
      content: "";
      position: absolute;
      background-color: #b2b7bf;
    }

    &::before {
      left: 50%;
      top: 0;
      width: 2px;
      height: 100%;
      transform: translateX(-50%);
    }

    &::after {
      top: 50%;
      left: 0;
      width: 100%;
      height: 2px;
      transform: translateY(-50%);
    }
  }

  span {
    font-size: 14px;
    font-weight: 400;
    color: #798497;
  }

  .delete {
    position: absolute;
    width: 25px;
    height: 25px;
    top: 6px;
    right: 6px;
  }
}

.question-images {
  margin-bottom: 10px;
}

.title-view .limitation {
  color: #747474;
}

.question-container {
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  // padding: 20px;
  padding: 10px;
  box-sizing: border-box;
  margin-bottom: 20px;
  position: relative;
}

.title-view {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 15px;
  word-break: break-all;
  margin-top: 0;
  width: 90%;
}

.asterisk {
  color: #f73b42;
  margin-right: 4px;
}

.question-images {
  img {
    width: 100%;
    display: block;
    margin-top: 15px;
  }
}

.choose-css {
  width: 100%;
  padding: 15px 20px;
  box-sizing: border-box;
  border-radius: 8px;
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
}

.choose-css-new {
  &:hover {
    opacity: 0.8;
  }
}

.choose-css-text {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.true-answer {
  font-size: 14px;
  color: #00c755;
  margin-right: 10px;
}

.correct-text {
  font-size: 15px;
  font-weight: 500;
  color: #00c755;
  margin-left: 8px;
}

.error-text {
  font-size: 15px;
  font-weight: 500;
  color: #f73b42;
  margin-left: 8px;
}

.explanation-section {
  margin-top: 20px;

  .section-title {
    font-size: 15px;
    font-weight: 500;
    color: #2b2f36;
    display: block;
    margin-bottom: 10px;
  }
}

.textarea-view {
  width: 100%;
  min-height: 100px;
  max-height: 200px;
  overflow-y: auto;
  // background: #f7f7f7;
  border: 1px solid #ededed;
  border-radius: 8px;
  padding: 12px 16px;
  box-sizing: border-box;
  word-break: break-all;
  line-height: 1.6;
  text-align: left;
}

.textarea-placeholder {
  color: #c0c4cc;
}

.question-images-box {
  position: relative;
  cursor: pointer;
  margin-top: 15px;

  .thumbnail-image {
    width: 100%;
    object-fit: cover;
    border-radius: 8px;
  }

  .fangda-box {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    text-align: center;
    padding: 8px;
    font-size: 12px;
    border-radius: 0 0 8px 8px;
  }
}

.fangda-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  .popup-content {
    background: white;
    border-radius: 8px;
    padding: 20px;
    max-width: 90%;
    max-height: 90%;
    position: relative;

    .popup-guanbi {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 30px;
      height: 30px;
      cursor: pointer;
    }

    .popup-scroll {
      max-height: 80vh;
      overflow-y: auto;

      img {
        width: 100%;
        margin-top: 10px;
      }
    }
  }
}

.guanbi {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ExamPreview/ExamPreviewIMAGE.vue